<template>
<div class="switch-user">

  <vue-headful
    title="Designbox - Switch User"
    description="Designbox"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'switch-user'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
            <b-field :label="$t('e-mail-new-user')">
            <b-input v-model="email"></b-input>
        </b-field>
        <b-button @click="switchUser" :disabled="email.length < 8" :loading="isActive">{{ $t ("switch-user") }}</b-button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert       from '@/components/MenuVert'
import Breadcrumbs    from '@/components/Breadcrumbs'
import { mapGetters } from 'vuex'
import axios from "axios";

export default {
    name:'SwitchUser',
    computed: { ...mapGetters(["getCurrentCompany", "getCompany", "getUserToken"])
    },
    data: function () {
        return {
            email: "",
            isActive: false
        }
    },
    components: {MenuVert, Breadcrumbs},
    methods: {
        switchUser () {
            this.isActive = true
            console.log (this.email)
            axios.post (`/vue/switch-user/`, {email: this.email},
                    { headers: {
                        Authorization: "Token " + this.getUserToken,
                        } }
                ).then (resp => {
                    const data = resp.data
                    if (! data.status) {
                        const messages = data.messages.join ("<br>")
                        this.$toastr("error", messages, this.$t("error"))
                        this.isActive = false
                    } else {
                        const rdata = data.data
                        const cid   = rdata.user.company [0]
                        this.$store.commit ("SET_TOKEN",       {token: rdata.jwt})
                        this.$store.commit ("SET_USERNAME",    rdata.user.username)
                        this.$store.commit ("SET_UID",         rdata.user.id)
                        this.$store.commit ("SET_COMPANY",     cid)
                        this.$store.commit ("SET_LOGIN_ACTIVE", false)
                        this.$store.commit ("SET_LINES",        {lines: rdata.user.lines, active: rdata.user.last_line})
                        this.$store.commit ("SET_GROUPS",       new Set (rdata.user.groups))
                        this.$router.push ({ name: "home"})
                    }
                }).catch(err => {
                    this.$toastr ("error", err.message, this.$t("error"))
                    this.isActive = false
                })
        }
    },
    created () {
        this.$store.dispatch("callCurrentCompany",{self: this,company: this.getCompany})
    }
}
</script>

<style>
.switch-user{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}

.loaderisactive{
    display:inline-block!important;
}
</style>
